import { AscRichTextViewer } from "../../..";
import styles from "../../AscRichTextEditor.module.scss";

interface PlaceholderProps {
  text?: string;
}
export function Placeholder({
  text = "Enter some rich text...",
}: PlaceholderProps) {
  return (
    <div className={styles["editor-placeholder"]}>
      <AscRichTextViewer inferValue={text} />
    </div>
  );
}
